// @flow

import { useFormikContext } from 'formik';
import React from 'react';
import { TABLEFLOW_RESOURCES_GRID_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { getDropdownOptions } from '@components/stream-governance/utils';
import { SelectField } from '@src/formik-utils/FormFields';
import { useMetaDataContext } from '@streaming-projects/orgs/contexts/SPMetaDataContextProvider';

import { TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG_MAP } from './tableflow-resource-inputs-config';

export const SPTableFlowStorageTypeContainer = ({
  disabled,
  disableOnFormErrors = null,
  fluid = null,
}) => {
  const { values } = useFormikContext();
  const tableFlowStorageConfig = TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG_MAP.get(
    TABLEFLOW_RESOURCES_GRID_FIELDNAMES.STORAGE_TYPE
  );
  const dataUniverse = useMetaDataContext().tableflow_configs.tableflow_params;
  const tableFlowStorageOptions = getDropdownOptions(
    dataUniverse,
    values,
    tableFlowStorageConfig,
    false,
    true,
    false,
    false,
    []
  );
  return (
    <SelectField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={tableFlowStorageConfig.displayName}
      fieldName={tableFlowStorageConfig.backendFieldName}
      fluid={fluid}
      options={tableFlowStorageOptions}
    />
  );
};
